import cx from 'classnames'
import { type SetStateAction, type Dispatch, useCallback } from 'react'
import { useSwipeable } from 'react-swipeable'

import { type SanityFrameBuilderTextureImage } from '../../data/sanity/queries/types/texture'

import ImageSlide, { type ImageSize } from './image-slide'

interface ImageSlidesProps {
  images: SanityFrameBuilderTextureImage[]
  selectedIndex: number
  onSwipedLeft: () => void
  onSwipedRight: () => void
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
  setCurrentImageSize: Dispatch<SetStateAction<ImageSize>>
  className?: string
}

const ImageSlides = ({
  images,
  selectedIndex,
  onSwipedLeft,
  onSwipedRight,
  setIsModalOpen,
  setCurrentImageSize,
  className,
}: ImageSlidesProps) => {
  const { ref, onMouseDown } = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
    delta: 20,
  })

  const handleClick = useCallback(() => {
    setIsModalOpen(false)
  }, [setIsModalOpen])

  return (
    <div
      ref={ref}
      onMouseDown={onMouseDown}
      onClick={handleClick}
      className={cx(
        'absolute top-0 right-0 bottom-0 left-0 flex transition-transform duration-200',
        className,
      )}
      style={{
        transform: `translateX(-${selectedIndex * 100}%)`,
      }}
    >
      {images.map((image, index) => (
        <ImageSlide
          key={index}
          index={index}
          selectedIndex={selectedIndex}
          textureImage={image}
          setCurrentImageSize={setCurrentImageSize}
          className="flex-none"
        />
      ))}
    </div>
  )
}

export default ImageSlides
